import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
import { gridSimple, createGridConfig, gridMultiple } from "./gridSettings/gridSettings"
export const AlboAutomezzo: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'descrizioneSoggetto - $descrizioneSede',
      titleForm: 'descrizioneSoggetto - $descrizioneSede',

      breadcrumbCaption: 'Categorie Automezzo',
      idBreadcrumbGroup: 'automezzo',
      campoTitle: ['descrizioneSede', 'descrizioneSoggetto'],
      masterKey: 'id',
      service: 'AlboAutomezzo',
      api: 'CategoriaAutomezzo',
      filterList: '/$idAutomezzo',
      filterEditor: '?id=$',
      formType: 'simple',
      helpDoc: 'CategorieAutomezzo.html',
      idTabRif: [
        {
          key: 'idAutomezzo',
          value: 'idAutomezzo'
        },
        {
          key: 'idSede',
          value: 'idSede'
        },
      ],
      queryFilter:
        [
          {
            key: 'id',
            value: 'idAutomezzo'
          }

        ],
      nCol: 1,
      toolbarSettings: {
        service: 'automezzo',

      }


    }

  },


  {
    itemType: "group", groupDataField: 'datiCategorie', colCount: "2", class: "col-12", caption: "Elenco Categorie Automezzo",
    data: [

      {
        allowHiding: false, showInColumnChooser: true,
        type: 'campoSpecial', editorType: 'dxSelectBox', dataField: "idCategoriaAlbo", caption: "Categ.albo", dataType: "", maxLength: '45',
        nCol: 1,
        colWidth: '100',
        allowFiltering: false,
        colVisible: true,
        validation: [
          { type: "required", message: "Campo Categ.albo Obbligatorio" }
        ],

        lista: {
          dataSource: 'CategoriaAlboGestore',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          queryString: "$filter=(soggetto eq 'T')",
          static: false,
        }
      },
      //CarrozzeriaAlboGestore
      {
        showInColumnChooser: false,
        type: 'campoSpecial',
        dataField: "listaCarrozzeriaAlboString",
        caption: "Carrozzerie",
        dataType: "",
        maxLength: '45',
        width: '50',
        nCol: 9,
        colVisible: false,
        disableOnUpdate: true,
        dynamic: {
          dataSource: 'CarrozzeriaAlboGestore',
          autocomplete: false,
          valueExpr: '',
          related: ['object|listaCarrozzeriaAlboGeneric'],
          service: '',
          displayExpr: 'descrizione',
          caption: "Lista Carrozzerie",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Carrozzerie Albo Gestore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia carrozzerie Albo Gestore',
            name: 'Carrozzerie Albo Gestore',
            location: 'after',

          },
          settingGrid: gridMultiple

        }
      },


    ]
  },
  {
    itemType: "group", caption: 'EER Automezzi autorizzati', groupDataField: 'datiListaCer', colCount: "1",
    data: [
      /*  { 
         showInColumnChooser:false,
         type: 'campoSpecial', 
         dataField: "listaCer", 
         caption: "Lista EER", 
         dataType: "", 
         maxLength: '45',
         width: '50',
         nCol:9,
         colVisible: true,
         disableOnUpdate:true,
         visible:false,
         dynamic: {
 
           dataSource: 'eer',
           autocomplete: false,
           valueExpr: 'object',
           displayExpr: 'id',
           caption: "Lista EER",
           componentType: 'dynamicGrid',
          
         }
       }, */
      {
        allowHiding: false, showInColumnChooser: true,
        type: 'campoGriglia', labelVisible: false, colSpan: "1", dataField: 'listaCer',

        caption: 'Lista EER',
        colVisible: true,
        width: 1400,
        colWidth: '100',
        /**Tipo Dynamico ma apre componente Griglia non in popup*/
        formGrid: {
          service: 'listaCer',
          api: '',
          remoteOperation: false,
          queryString: '',
          isEditable: true,
          isEditableNewRow: true,
          isEditableEditRow: true,
          isEditableDeleteRow: true,
          showToolbarTop: true,
          tableHeight: 350,
          tableWidth: 1000,
          showFilter: false,
          selectionRowMode: 'none',  // 'single' | 'detail' | 'multiple';
          idTable: 'listaCer',
          isSearchable: false,
          toolbarCustomButtons: [
            {
              id: 'CopiaCerDaAlboCarrozzeria',
              name: 'Copia elenco EER',
              text: 'Copia E.E.R. dalla Categoria Albo',
              icon: 'glyphicon mdi mdi-playlist-plus',
              disabled: false,
              visible: true,
              widget: 'button'
            },
            {
              id: 'CopiaCerDaCategoriaAutomezzo',
              name: 'Copia elenco EER',
              text: 'Copia E.E.R. da altro Automezzo',
              icon: 'glyphicon mdi mdi-playlist-plus',
              disabled: false,
              visible: true,
              widget: 'button'
            },
          ]
        }




      },

    ]

  },
]